
import React from 'react';
import { Sidebar as SidebarComponent } from '@/components/ui/sidebar';
import { useAuth } from '@/contexts/AuthContext';
import {
  DashboardGroup,
  PatientsGroup,
  AppointmentsGroup,
  PerformanceGroup,
  ProfileGroup,
  SupportGroup,
  MarketingGroup
} from './groups';

const DoctorSidebar = () => {
  // Wrap useAuth in try-catch to prevent error if no AuthProvider
  let user = null;
  try {
    const auth = useAuth();
    user = auth?.user;
  } catch (error) {
    console.warn("AuthProvider not found. Some features might not work properly.");
  }

  return (
    <SidebarComponent className="hidden md:block border-r border-border w-64 py-4 px-2 shrink-0">
      <div className="px-3 py-2 mb-6">
        <h2 className="text-xl font-bold text-primary">ask.dentist<span className="text-sm opacity-70">Doctor</span></h2>
      </div>
      
      <div className="space-y-1">
        <DashboardGroup />
        <PatientsGroup />
        <AppointmentsGroup />
        <PerformanceGroup />
        <MarketingGroup />
        <ProfileGroup />
        <SupportGroup />
      </div>
    </SidebarComponent>
  );
};

export default DoctorSidebar;
